@for (group of groups(); track group.group; let first = $first) {
  <div data-test="kp-type-menu-group" class="flex flex-col gap-2" [class]="first ? '' : 'border-t border-border pt-4'">
    @for (row of group.rows; track row.type) {
      <button
        type="button"
        role="menuitem"
        data-test="kp-type-menu-item"
        [attr.aria-current]="row.active"
        class="flex h-16 w-full shrink-0 cursor-pointer items-center gap-4 rounded px-4 text-left text-base focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue-600"
        [class]="row.active ? 'bg-blue-50' : 'hover:bg-gray-50'"
        (click)="select(row.type)"
      >
        <app-icon class="shrink-0 text-gray-500" [name]="row.icon" [size]="20" />
        <span
          data-test="kp-type-menu-label"
          class="min-w-0 flex-1 truncate"
          [class]="row.active ? 'font-medium text-blue-600' : 'text-gray-950'"
          >{{ row.label }}</span
        >
        <app-kp-count-badge data-test="kp-type-menu-count" [count]="row.count" />
      </button>
    }
  </div>
}
